import { AuthProvider } from 'tradera/apps/login/auth-provider';
import { PREVIOUS_LOGIN_METHOD_2 } from 'tradera/constants/cookies';
import { useCookieUtil } from 'tradera/hooks/use-cookie-util';

export const emailLoginMethod = 'email';

export const usePreviousLoginMethod: () => [
    string | null,
    (method: AuthProvider | typeof emailLoginMethod) => void,
] = () => {
    const cookieUtil = useCookieUtil();
    const previousLoginMethod = cookieUtil.getCookie(PREVIOUS_LOGIN_METHOD_2);

    const setPreviousLoginMethod = (
        method: AuthProvider | typeof emailLoginMethod,
    ) => {
        cookieUtil.createCookie(
            PREVIOUS_LOGIN_METHOD_2,
            method,
            new Date(Date.now() + 1000 * 60 * 60 * 24 * 365),
            '/',
            undefined,
            true,
        );
    };

    return [previousLoginMethod ?? null, setPreviousLoginMethod];
};

export const hasLoggedInWithExternalProvider = (cookieValue: string) => {
    return cookieValue && cookieValue !== 'email';
};

export const hasLoggedInWithEmail = (cookieValue: string) => {
    return !!(cookieValue && cookieValue === emailLoginMethod);
};

export const hasLoggedInWithKlarna = (cookieValue: string) => {
    return !!(cookieValue && cookieValue === AuthProvider.Klarna);
};

export const hasLoggedInWithFacebook = (cookieValue: string) => {
    return !!(cookieValue && cookieValue === AuthProvider.Facebook);
};

export const hasLoggedInWithApple = (cookieValue: string) => {
    return !!(cookieValue && cookieValue === AuthProvider.Apple);
};

export const hasLoggedInWithGoogle = (cookieValue: string) => {
    return !!(cookieValue && cookieValue === AuthProvider.Google);
};
